/* istanbul ignore file */
export { default } from './TransactionDialog';
